import "./TheMenu.module.css";
import Header from "@/reusable_sections/Header";
import CulinaryJourney from "./sections/CulinaryJourney";
import OurLocalPartners from "./sections/OurLocalPartners";
import Footer from "@/reusable_sections/Footer";
export default function TheMenuPage() {
  return <div>
      <Header />
      <CulinaryJourney />
      <OurLocalPartners />
      <Footer />
    </div>;
}